// 默认字体大小
export const DEFAULT_FONT_SIZE = 14;

export const getWidthByText = (text: string, fontSize?: number) => {
    const _fontSize = fontSize || DEFAULT_FONT_SIZE;
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    // SSR、jsdom 或受限浏览器可能无法提供 2D 上下文，使用近似宽度保证操作列仍可完成布局计算。
    if (!context) {
        return Array.from(text).reduce(
            (width, character) => width + (character.charCodeAt(0) <= 0xff ? _fontSize / 2 : _fontSize),
            0
        );
    }
    context.font = `${_fontSize}px Microsoft YaHei`;
    return context.measureText(text).width;
};
